import { IllumiLogoMark } from "@src/components/illumi-logo-mark";
import clsx from "clsx";
import { Suspense, lazy } from "react";
import { createPortal } from "react-dom";
import { AgentChatHeader } from "./agent-chat-header";
import { AgentChatLayout } from "./agent-chat-layout";

const AgentChatPanel = lazy(() =>
	import("./components/agent-chat-panel").then((module) => ({
		default: module.AgentChatPanel,
	})),
);

const AGENT_CHAT_FULLSCREEN_Z_INDEX = 3500;

type AgentChatFullscreenProps = {
	isOpen: boolean;
	onClose: () => void;
	onCollapse: () => void;
};

export function AgentChatFullscreen({
	isOpen,
	onClose,
	onCollapse,
}: AgentChatFullscreenProps) {
	if (!isOpen) {
		return null;
	}

	return createPortal(
		<div
			className={clsx(
				"fixed inset-0 flex min-h-0 flex-col bg-surface-default select-text",
			)}
			style={{ zIndex: AGENT_CHAT_FULLSCREEN_Z_INDEX }}
			data-ui-id="agent-chat-fullscreen"
		>
			<AgentChatLayout
				header={
					<AgentChatHeader
						layout="fullscreen"
						onClose={onClose}
						onCollapse={onCollapse}
					/>
				}
			>
				<div
					className="flex min-h-0 flex-1 flex-col overflow-hidden"
					data-ui-id="agent-chat-fullscreen-panel"
				>
					<Suspense
						fallback={
							<div className="flex h-full w-full items-center justify-center">
								<IllumiLogoMark animated />
							</div>
						}
					>
						<AgentChatPanel />
					</Suspense>
				</div>
			</AgentChatLayout>
		</div>,
		document.body,
	);
}
